// First-party, cookie-light analytics for ad conversion tracking.
// No third-party trackers — events post to our own backend.
import { API } from "./brands";

const ATTR_KEY = "genie_attribution";
const VARIANT_KEY = "genie_variant";

// Two A/B variants of the /get-help hero. Add more here to test further.
export const HERO_VARIANTS = {
  a: {
    eyebrow: "Real help, fast",
    headline: "Stuck on hold? Skip the maze and get a specialist on your side.",
    sub:
      "It's Genie Assist is an independent directory of verified official support contacts — plus optional live specialists who help you get your issue sorted, fast.",
    cta: "Chat with a specialist",
  },
  b: {
    eyebrow: "Talk to a human in minutes",
    headline: "Real support help in minutes — not hours stuck on hold.",
    sub:
      "Describe your problem once and a specialist helps you reach the right official support line. First message is free — you only pay when you're ready.",
    cta: "Get help now",
  },
  c: {
    eyebrow: "Backed by a money-back promise",
    headline: "Get your support issue sorted — or your money back.",
    sub:
      "Chat with an independent specialist who helps you reach the right official support. Choose Urgent and if no one responds within 15 minutes, you're refunded automatically.",
    cta: "Start with a specialist",
  },
};

// Pick the A/B variant: ?v= in the URL wins; otherwise a remembered 50/50 split.
export function resolveVariant() {
  try {
    const urlV = new URLSearchParams(window.location.search).get("v");
    if (urlV && HERO_VARIANTS[urlV]) {
      localStorage.setItem(VARIANT_KEY, urlV);
      return urlV;
    }
    const stored = localStorage.getItem(VARIANT_KEY);
    if (stored && HERO_VARIANTS[stored]) return stored;
    const keys = Object.keys(HERO_VARIANTS);
    const picked = keys[Math.floor(Math.random() * keys.length)];
    localStorage.setItem(VARIANT_KEY, picked);
    return picked;
  } catch {
    return "a";
  }
}

// Capture UTM params on entry and remember them for the whole visit.
export function captureAttribution() {
  try {
    const p = new URLSearchParams(window.location.search);
    const incoming = {
      source: p.get("utm_source") || p.get("source"),
      campaign: p.get("utm_campaign") || p.get("campaign"),
      medium: p.get("utm_medium") || p.get("medium"),
    };
    const existing = getAttribution();
    const merged = {
      source: incoming.source || existing.source || null,
      campaign: incoming.campaign || existing.campaign || null,
      medium: incoming.medium || existing.medium || null,
      variant: localStorage.getItem(VARIANT_KEY) || existing.variant || null,
    };
    localStorage.setItem(ATTR_KEY, JSON.stringify(merged));
    return merged;
  } catch {
    return {};
  }
}

export function getAttribution() {
  try {
    return JSON.parse(localStorage.getItem(ATTR_KEY) || "{}");
  } catch {
    return {};
  }
}

// Fire-and-forget event. Never blocks or throws into the UI.
export function track(event, extra = {}) {
  const attr = getAttribution();
  const body = {
    event,
    variant: extra.variant || attr.variant || null,
    source: attr.source || null,
    campaign: attr.campaign || null,
    medium: attr.medium || null,
    path: typeof window !== "undefined" ? window.location.pathname : null,
    ...extra,
  };
  try {
    const url = `${API}/track-event`;
    const payload = JSON.stringify(body);
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([payload], { type: "application/json" }));
    } else {
      fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true }).catch(() => {});
    }
  } catch {
    /* analytics must never break the app */
  }
}
